import { GET_MODEL_TRIMS, GET_MODEL_TRIMS_SUCCEEDED, GET_MODEL_TRIMS_FAILED, USER_OPENED_EDIT_TRIM_MODEL_CHOOSER } from '../constants';

const initialState = {
  loading: false,
  trimSelected: false,
  trims: {},
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case GET_MODEL_TRIMS:
      return {
        ...state,
        loading: true,
      };

    case GET_MODEL_TRIMS_SUCCEEDED: {
      const newState = {
        ...state
      }
      let trims = {
        ...state.trims
      }
      trims = action.result;
      newState.trims[action.modelLineCode] = trims;
      return newState;
    }

    case GET_MODEL_TRIMS_FAILED:
      return {
        ...state,
        loading: false,
        trims: {},
        error: action.error
      };

    case USER_OPENED_EDIT_TRIM_MODEL_CHOOSER:
      return {
        ...state,
        trimSelected: true
      }

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/trims.js
 **/